






























































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import CutTypeMenu from "@/components/CutTypeMenu.vue";
import ReservationDoneDialog from "@/components/ReservationDoneDialog.vue";
import ReservationForm from "@/components/ReservationForm.vue";
import ReservationFailDialog from "@/components/ReservationFailDialog.vue";
import axios from "axios";
import emailjs from "emailjs-com";
declare let require: any;

@Component({
  components: {
    CutTypeMenu,
    ReservationDoneDialog,
    ReservationFailDialog,
    ReservationForm
  },
  props: {
    availableTimes: Array,
    e1: {
      type: Number,
      default: 1
    },
    reservationDate: String,
    reservationTime: String,
    backImage: {
      type: String,
      default: require("@/assets/images/barbershop.jpg")
    },
    okStep1: {
      type: Boolean,
      default: true
    },
    okStep2: {
      type: Boolean,
      default: true
    },
    okStep3: {
      type: Boolean,
      default: true
    },
    dialog: {
      type: Boolean,
      default: false
    },
    failDialog: {
      type: Boolean,
      default: false
    },
    valid: {
      type: Boolean,
      default: false
    },
    waitingDatesRequest: {
      type: Boolean,
      default: false
    }
  }
})
export default class Reservation extends Vue {
  [x: string]: any;
  cutType!: string;
  cutTag!: string;
  barber!: string;
  reservationDate!: string;
  reservationTime!: string;
  todayDate!: string;
  reservationForm!: Record<string, any>;
  allowedDates!: Record<string, any>;
  availableTimes!: Array<string>;
  reservation!: Record<string, any>;
  okStep1!: boolean;
  okStep2!: boolean;
  okStep3!: boolean;
  dialog!: boolean;
  failDialog!: boolean;
  valid!: boolean;
  waitingDatesRequest!: boolean;
  elementNumber!: string;
  cuts!: Array<Record<string, any>>;
  e1!: number;

  barbers = [
    {
      id: 1,
      name: this.$store.getters.barbers[0].name,
      photo: this.$store.getters.barbers[0].photo,
      borderStyle: "none"
    },
    {
      id: 2,
      name: this.$store.getters.barbers[1].name,
      photo: this.$store.getters.barbers[1].photo,
      borderStyle: "none"
    }
  ];

  async createReservation() {
    this.reservation = {
      date: this.reservationDate,
      time: this.reservationTime,
      name: this.reservationForm["customerName"],
      surname: this.reservationForm["customerSurname"],
      email: this.reservationForm["customerMail"],
      phoneNumber: this.reservationForm["customerPhoneNumber"],
      note: this.reservationForm["customerNote"],
      barber: this.barber,
      cutType: this.cutType,
      cutTag: this.cutTag
    };

    await axios
      .post(
        process.env.VUE_APP_GEMERBARBIER_API +
          "reservation?date=" +
          this.reservationDate +
          "&time=" +
          this.reservationTime +
          "&name=" +
          this.reservationForm["customerName"] +
          "&surname=" +
          this.reservationForm["customerSurname"] +
          "&email=" +
          this.reservationForm["customerMail"] +
          "&phoneNumber=" +
          this.reservationForm["customerPhoneNumber"] +
          "&note=" +
          this.reservationForm["customerNote"] +
          "&barber=" +
          this.barber +
          "&cutTag=" +
          this.cutTag
      )
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      .then(response => {
        this.reserveTime();
        this.sendMail();
        this.dialog = true;
      })
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      .catch(err => {
        this.failDialog = true;
      });
  }

  private async reserveTime() {
    await axios.post(
      process.env.VUE_APP_GEMERBARBIER_API +
        "/reserveTime?date=" +
        this.reservationDate +
        "&time=" +
        this.reservationTime +
        "&barber=" +
        this.barber +
        "&cutTag=" +
        this.cutTag
    );
  }

  private sendMail(): void {
    emailjs.send(
      process.env.VUE_APP_EMAIL_ADDRESS,
      process.env.VUE_APP_EMAIL_TEMPLATE,
      this.reservation,
      process.env.VUE_APP_EMAIL_USER_CODE
    );
  }

  setBarber(barberName: string, id: number) {
    this.barbers.forEach(c => (c.borderStyle = "none"));
    this.barbers[id - 1].borderStyle = "solid";
    this.barber = barberName;
    this.okStep1 = false;
    this.todayDate = new Date().toISOString().substr(0, 10);
    this.scrollDown();
  }

  setCutType(
    cutType: string,
    cutTag: string,
    cuts: Array<Record<string, any>>
  ) {
    this.cuts = cuts;
    this.cutType = cutType;
    this.cutTag = cutTag;
    this.scrollDown();
    this.okStep2 = false;
  }

  async getAvailableDates() {
    this.waitingDatesRequest = true;
    await axios
      .get(
        process.env.VUE_APP_GEMERBARBIER_API +
          "/availableDates/?barber=" +
          this.barber +
          "&cutTag=" +
          this.cutTag,
        { timeout: 30000 }
      )
      .then((response: any) => {
        this.allowedDates = (val: any) => response.data.indexOf(val) !== -1;
        this.waitingDatesRequest = false;
        this.e1 = 3;
        this.goStep3();
      });
  }

  @Watch("reservationDate")
  async getAvailableTimes() {
    if (this.reservationDate != "") {
      await axios
        .get(
          process.env.VUE_APP_GEMERBARBIER_API +
            "/availableTimes/?date=" +
            this.reservationDate +
            "&barber=" +
            this.barber +
            "&cutTag=" +
            this.cutTag
        )
        .then(response => {
          this.availableTimes = response.data;
          this.reservationTime = this.availableTimes[0];
        });
    }
    this.scrollDown();
  }

  setValidForm(valid: boolean): void {
    this.valid = valid;
  }

  setReservationForm(form: object): void {
    this.reservationForm = form;
  }

  scrollToHead() {
    window.scrollTo(0, 0);
  }

  scrollDown() {
    if (this.$vuetify.breakpoint.xs) {
      this.$vuetify.goTo(document.body.scrollHeight);
    }
  }

  goStep3() {
    this.scrollToHead();
    this.availableTimes = [];
    this.reservationDate = "";
    this.elementNumber = "";
    this.okStep3 = true;
  }

  goStep2() {
    this.scrollToHead();
    this.cuts["color"] = "black";
    this.okStep2 = true;
  }
}
